import { Injectable } from '@angular/core';
import { BaseAdapter } from '@data/base/base-adapter.type';
import { PaymentMethodsResponseDto, PaymentMethodItemDto, PaymentTermDto, HeaderIconDto } from '@data/data/models/payment-method.dto';
import { PaymentType } from '@data/domain/enums/payment.constant';
import { PaymentMethod, PaymentMethodItem, PaymentTerm } from '@data/domain/payment-method.entity';
import { ITEM } from '@utils/constants';

@Injectable({
  providedIn: 'root'
})
export class PaymentMethodMapper
  implements BaseAdapter<PaymentMethodsResponseDto, PaymentMethod[]>
{
  mapFrom(dto: PaymentMethodsResponseDto): PaymentMethod[] {
    if (!dto?.data || !Array.isArray(dto.data)) {
      return [];
    }

    return dto.data.map((group) => {
      return {
        title: group.title || '',
        type: group.type || PaymentType.unknown,
        list: group.list?.map((item) => this.toDomainItem(item)) || [],
        headerIcon: group.header_icon?.length
          ? group.header_icon?.map((icon) => this.toDomainHeaderIcon(icon))
          : []
      };
    });
  }

  private toDomainItem(dto: PaymentMethodItemDto): PaymentMethodItem {
    const item: PaymentMethodItem = {
      bankName: dto.bank_name || (dto.bank_name === '' ? dto.title : ''),
      icon: dto.icon || '',
      paymentMethod: dto.payment_method || '',
      title: dto.title || '',
      howToPay: dto.how_to_pay,
      term: dto.term ? dto.term.map((term) => this.toDomainTerm(term)) : []
    };
  
    if (dto.source_type) {
      item.sourceType = dto.source_type;
    }
  
    return item;
  }
  
  private toDomainTerm(dto: PaymentTermDto): PaymentTerm {
    return {
      installTerm: dto.install_term || ITEM.DEFAULT_VALUE,
      title: dto.title || ''
    };
  }
  
  private toDomainHeaderIcon(dto: HeaderIconDto): HeaderIconDto {
    return {
      icon: dto.icon || ''
    };
  }
}
